import { render, staticRenderFns } from "./RetailerMap.vue?vue&type=template&id=5f80c158&"
import script from "./RetailerMap.vue?vue&type=script&lang=ts&"
export * from "./RetailerMap.vue?vue&type=script&lang=ts&"
import style0 from "./RetailerMap.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports